import React, { useState, useEffect } from "react";
import './styles.css'
import CommonScreenContent from "../../../components/screen/common-screen-content/commonScreenContent";
import ScreenLabel from "../../../components/label/screen-label/screenLabel";
import Loader from '../../../components/loader/loader.component'
import { ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { useDispatch, useSelector } from 'react-redux'
import { displayErrorToast, displaySuccessToast, isEmpty, isLoggedInUserBusiness, isLoggedInUserEmployee, isNull, removeSpecialCharAndChangeToPascal } from "../../../utils/Utils";
import { userBusinessListRequest } from '../../../redux/business/business.action'
import { businessLocationListRequest } from '../../../redux/business-location/businessLocation.action'
import { newTaxRuleRequest, newTaxRuleRequestStatus, taxRuleListRequest,
    updateTaxRuleRequest, updateTaxRuleRequestStatus
 } from '../../../redux/payroll/payroll.action'
import CommonInputRow from "../../../components/input/common-input-row/commonInputRow";
import FormFieldLabel from "../../../components/label/form-field-label/formFieldLabel";
import Select from 'react-select'
import { API_CONSTANTS, APP_CONSTANTS } from "../../../utils/AppConstants";
import Modal from 'react-bootstrap/Modal';
import CommonInputFloatFull from "../../../components/input/common-input-float-full/commonInputFloatFull";
import PercentInputHalf from "../../../components/input/percent-input-half/percentInputHalf";
import CommonInputFloatHalf from "../../../components/input/common-input-float-half/commonInputFloafHalf";
import ButtonRow from "../../../components/button/button-row/buttonRow";
import CommonButton from "../../../components/button/common-button/commonButton";

const TaxRuleList = props => {
    const dispatch = useDispatch()
    const [isLoading, setLoading] = useState(false)
    const { user, employeeSelectedBusiness, employeeSelectedLocation } = useSelector((state) => state.user)
    const { userBusinessListSuccess, userBusinessListError } = useSelector(state => state.business)
    const { businessLocationListSuccess, businessLocationListError } = useSelector(state => state.businessLocation)
    const { newTaxRuleSuccess, newTaxRuleError, newTaxRuleReqStatus,
        updateTaxRuleSuccess, updateTaxRuleError, updateTaxRuleReqStatus,
        taxRuleListSuccess, taxRuleListError } = useSelector(state => state.payroll)
    const [selectedBusiness, setSelectedBusiness] = useState()
    const [selectedLocation, setSelectedLocation] = useState()
    const [name, setName] = useState('')
    const [value, setValue] = useState('')
    const [selectedType, setSelectedType] = useState()
    const [selectedPriority, setSelectedPriority] = useState()
    const [minimumAmount, setMinimumAmount] = useState('')
    const [maximumAmount, setMaximumAmount] = useState('')
    const TAX_TYPE_LIST = [
        { key: 'FIXED', value: removeSpecialCharAndChangeToPascal('FIXED') },
        { key: 'PERCENTAGE', value: removeSpecialCharAndChangeToPascal('PERCENTAGE') }
    ]
    const PRIORITY_LIST = [
        { key: 1, value: 1 },
        { key: 2, value: 2 },
        { key: 3, value: 3 },
        { key: 4, value: 4 },
        { key: 5, value: 5 }
    ]
    const [showAddTaxRuleModal, setShowAddTaxRuleModal] = useState(false)
    const [showEditRuleModal, setShowEditRuleModal] = useState(false)
    const [selectedRule, setSelectedRule] = useState(null)

    const customSelectStyles = {
        menu: (provided) => ({
            ...provided,
            backgroundColor: "#fff", // Ensures dropdown background is white
            zIndex: 5
        }),
        option: (provided, state) => ({
            ...provided,
            cursor: "pointer"
        }),
    };

    useEffect(() => {
        if (isLoggedInUserBusiness(user)) {
            sessionStorage.setItem(APP_CONSTANTS.SCREEN.TAX_RULES_LIST, true)
            fetchBusinessList()
        } else if (isLoggedInUserEmployee(user)) {
            fetchTaxRules()
        }
    }, [])

    const fetchBusinessList = () => {
        setLoading(true)
        const data = {
            userId: user.data.userDetails.userId
        }
        dispatch(userBusinessListRequest(data))
    }

    const fetchBusinessLocation = () => {
        if (!isEmpty(selectedBusiness)) {
            setLoading(true)
            dispatch(businessLocationListRequest(selectedBusiness.businessId))
        }
    }

    useEffect(() => {
        if (!isEmpty(taxRuleListSuccess)) {
            setLoading(false)
        } else if (!isEmpty(taxRuleListError)) {
            setLoading(false)
        }
    }, [taxRuleListSuccess, taxRuleListError])

    useEffect(() => {
        if (newTaxRuleReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(newTaxRuleSuccess.data?.message)
            fetchTaxRules()
            clearFields()
        } else if (newTaxRuleReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(newTaxRuleError.message)
        }
        if (newTaxRuleReqStatus?.length) {
            dispatch(newTaxRuleRequestStatus(''))
        }
    }, [newTaxRuleSuccess, newTaxRuleError, newTaxRuleReqStatus])
    
    useEffect(() => {
        if (updateTaxRuleReqStatus === API_CONSTANTS.SUCCESS_STATUS) {
            setLoading(false)
            displaySuccessToast(updateTaxRuleSuccess.data?.message)
            fetchTaxRules()
            clearFields()
        } else if (updateTaxRuleReqStatus === API_CONSTANTS.ERROR_STATUS) {
            setLoading(false)
            displayErrorToast(updateTaxRuleError.message)
        }
        if (updateTaxRuleReqStatus?.length) {
            dispatch(updateTaxRuleRequestStatus(''))
        }
    }, [updateTaxRuleSuccess, updateTaxRuleError, updateTaxRuleReqStatus])

    useEffect(() => {
        if (!isEmpty(userBusinessListSuccess)) {
            setLoading(false)
            if (sessionStorage.getItem(APP_CONSTANTS.SCREEN.TAX_RULES_LIST) === 'true') {
                sessionStorage.setItem(APP_CONSTANTS.SCREEN.TAX_RULES_LIST, false)
                setSelectedBusiness(userBusinessListSuccess.data[0])
            }
        } else if (!isEmpty(userBusinessListError)) {
            setLoading(false)
        }
    }, [userBusinessListSuccess, userBusinessListError])

    useEffect(() => {
        if (!isEmpty(businessLocationListSuccess)) {
            setLoading(false)
            setSelectedLocation(businessLocationListSuccess.data[0])
        } else if (!isEmpty(businessLocationListError)) {
            setLoading(false)
        }
    }, [businessLocationListSuccess, businessLocationListError])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedBusiness)) {
            fetchBusinessLocation()
        }
    }, [selectedBusiness])

    useEffect(() => {
        if (isLoggedInUserBusiness(user) === true && !isNull(selectedLocation)) {
            fetchTaxRules()
        }
    }, [selectedLocation])

    const fetchTaxRules = () => {
        if (isLoggedInUserBusiness(user) && isEmpty(selectedBusiness) && isEmpty(selectedLocation)) {
            return
        }
        if (isLoggedInUserEmployee(user) && isEmpty(employeeSelectedBusiness) && isEmpty(employeeSelectedLocation)) {
            return
        }
        setLoading(true)
        const data = {
            businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
            locationId: isLoggedInUserEmployee(user) ? selectedLocation.locationId : employeeSelectedLocation
        }
        dispatch(taxRuleListRequest(data))
    }

    const clearFields = () => {
        setName('')
        setValue('')
        setSelectedType()
        setSelectedPriority()
        setMinimumAmount('')
        setMaximumAmount('')
    }

    const handleAddTaxRuleSubmitClick = () => {
        if (isEmpty(name)) {
            displayErrorToast('Tax name cannot be blank')
        } else if (isEmpty(value)) {
            displayErrorToast('Tax value cannot be blank')
        } else if (isEmpty(selectedType)) {
            displayErrorToast('Tax value type not selected')
        } else if (isEmpty(minimumAmount)) {
            displayErrorToast('Minimum amount cannot be blank')
        } else if (parseFloat(minimumAmount) < 0) {
            displayErrorToast('Invalid minimum amount')
        } else if (isEmpty(maximumAmount)) {
            displayErrorToast('Maximum amount cannot be blank')
        } else if (parseFloat(maximumAmount) < 0) {
            displayErrorToast('Invalid maximum amount')
        } else if (isEmpty(selectedPriority)) {
            displayErrorToast('Tax priority not selected')
        } else {
            setLoading(true)
            const data = {
                name: name,
                type: selectedType.key,
                locationId: isLoggedInUserBusiness(user) ? selectedLocation.locationId : employeeSelectedLocation,
                businessId: isLoggedInUserBusiness(user) ? selectedBusiness.businessId : employeeSelectedBusiness,
                value: parseFloat(value),
                minAmount: parseFloat(minimumAmount),
                maxAmount: parseFloat(maximumAmount),
                priority: selectedPriority.key
            }
            dispatch(newTaxRuleRequest(data))
            setShowAddTaxRuleModal(false)
        }
    }

    const handleUpdateTaxRuleSubmitClick = () => {
        if (isEmpty(selectedRule)) {
            displayErrorToast('Tax not selected. Please try again')
        } else if (isEmpty(name)) {
            displayErrorToast('Tax name cannot be blank')
        } else if (isEmpty(value)) {
            displayErrorToast('Tax value cannot be blank')
        } else if (isEmpty(selectedType)) {
            displayErrorToast('Tax value type not selected')
        } else if (isEmpty(minimumAmount)) {
            displayErrorToast('Minimum amount cannot be blank')
        } else if (parseFloat(minimumAmount) < 0) {
            displayErrorToast('Invalid minimum amount')
        } else if (isEmpty(maximumAmount)) {
            displayErrorToast('Maximum amount cannot be blank')
        } else if (parseFloat(maximumAmount) < 0) {
            displayErrorToast('Invalid maximum amount')
        } else if (isEmpty(selectedPriority)) {
            displayErrorToast('Tax priority not selected')
        } else {
            setLoading(true)
            const data = {
                taxRuleId: selectedRule.taxRuleId,
                name: name,
                type: selectedType.key,
                value: parseFloat(value),
                minAmount: parseFloat(minimumAmount),
                maxAmount: parseFloat(maximumAmount),
                priority: selectedPriority.key
            }
            dispatch(updateTaxRuleRequest(data))
            setShowEditRuleModal(false)
        }
    }

    const handleEditClick = (item) => {
        setSelectedRule(item)
        setName(item.name)
        setMinimumAmount(item.minAmount)
        setMaximumAmount(item.maxAmount)
        setValue(item.value)
        const selType = TAX_TYPE_LIST.find(e => e.key === item.type)
        if (!isEmpty(selType)) {
            setSelectedType(selType)
        }
        const selPriority = PRIORITY_LIST.find(e => parseFloat(e.key) === parseFloat(item.priority))
        if (!isEmpty(selPriority)) {
            setSelectedPriority(selPriority)
        }
        setShowEditRuleModal(true)
    }

    return (
        <>
            <CommonScreenContent>
                <ScreenLabel label='Tax Rules' />
                {isLoggedInUserBusiness(user) === true && <CommonInputRow>
                    <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Business' />
                        {!isEmpty(userBusinessListSuccess) && !isEmpty(userBusinessListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedBusiness}
                            getOptionLabel={e => e.businessName}
                            getOptionValue={e => e}
                            options={userBusinessListSuccess.data}
                            placeholder='Select Business'
                            onChange={e => setSelectedBusiness(e)} />}
                        {!isEmpty(userBusinessListError) && <div className="p-text">{userBusinessListError.message}</div>}
                    </div>
                    {!isEmpty(selectedBusiness) && <div className="select-half-width">
                        <FormFieldLabel className='up-bold-label' label='Select Location' />
                        {!isEmpty(businessLocationListSuccess) && !isEmpty(businessLocationListSuccess.data) && <Select
                            className='select-full-width-no-border'
                            value={selectedLocation}
                            getOptionLabel={e => e.name}
                            getOptionValue={e => e}
                            options={businessLocationListSuccess.data}
                            placeholder='Select Location'
                            onChange={e => setSelectedLocation(e)} />}
                        {!isEmpty(businessLocationListError) && <div className="p-text">{businessLocationListError.message}</div>}
                    </div>}
                </CommonInputRow>}
                {!isEmpty(taxRuleListSuccess) && !isEmpty(taxRuleListSuccess.data) && <div className="table-scroll-container">
                    <table className="table table-hover mt-4">
                        <thead>
                            <tr>
                                <th scope="col">Name</th>
                                <th scope="col" className="text-center">Type</th>
                                <th scope="col" className="text-center">Value</th>
                                <th scope="col" className="text-center">Min. Amount</th>
                                <th scope="col" className="text-center">Max. Amount</th>
                                <th scope="col" className="text-center">Priority</th>
                                <th scope="col" className="text-center">Action</th>
                            </tr>
                        </thead>
                        <tbody>
                            {taxRuleListSuccess.data.map(element => (
                                <tr className="loc-table-row-container">
                                    <td>{!isEmpty(element.name) ? element.name : ''}</td>
                                    <td className="text-center">{removeSpecialCharAndChangeToPascal(element.type)}</td>
                                    <td className="text-center">{element.value}</td>
                                    <td className="text-center">{element.minAmount}</td>
                                    <td className="text-center">{element.maxAmount}</td>
                                    <td className="text-center">{element.priority}</td>
                                    <td className="text-center">
                                        <div className="loc-list-button-container">
                                            <div className="loc-list-button" onClick={() => { handleEditClick(element) }}><div className="tr-action-btn">Edit</div></div>
                                        </div>
                                    </td>
                                </tr>
                            ))}

                        </tbody>
                    </table>
                </div>}
                {!isEmpty(taxRuleListError) && <div className="content-error">{taxRuleListError.message}</div>}
                <div className="vl-fab-container" onClick={() => setShowAddTaxRuleModal(true)}>
                    <img src={require('../../../assets/plus_icon.png')} className="vl-fab-icon" />
                </div>
            </CommonScreenContent>
            <Modal
                onHide={() => {
                    setShowAddTaxRuleModal(false)
                }}
                show={showAddTaxRuleModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        New Tax Rule
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormFieldLabel label='Enter details to add new tax rule' />
                    <CommonInputFloatFull
                        type='text'
                        id='name'
                        onChange={e => setName(e.target.value)}
                        placeholder='Tax Name'
                        value={name}
                    />
                    <FormFieldLabel label='Select Value Type' />
                    {TAX_TYPE_LIST && <Select
                        styles={customSelectStyles}
                        className='select-full-width-no-border'
                        value={selectedType}
                        getOptionLabel={e => e.value}
                        getOptionValue={e => e}
                        options={TAX_TYPE_LIST}
                        placeholder='Select Value Type'
                        onChange={e => setSelectedType(e)} />}
                    {!isEmpty(selectedType) && selectedType.key === 'FIXED' && <CommonInputFloatFull
                        type='number'
                        id='valueNumber'
                        onChange={e => setValue(e.target.value)}
                        placeholder='Value'
                        value={value}
                    />}
                    {!isEmpty(selectedType) && selectedType.key !== 'FIXED' && <PercentInputHalf
                        type='number'
                        id='valueFixed'
                        onChange={e => setValue(e.target.value)}
                        placeholder='Value'
                        value={value}
                        isFullWidth={true}
                    />}
                    {!isEmpty(selectedType) && <CommonInputRow>
                        <CommonInputFloatHalf
                            type='number'
                            id='minAmount'
                            onChange={e => setMinimumAmount(e.target.value)}
                            placeholder='Min. Amount'
                            value={minimumAmount}
                        />
                        <CommonInputFloatHalf
                            type='number'
                            id='maxAmount'
                            onChange={e => setMaximumAmount(e.target.value)}
                            placeholder='Max. Amount'
                            value={maximumAmount}
                        />
                    </CommonInputRow>}
                    <FormFieldLabel label='Select Priority' />
                    {PRIORITY_LIST && <Select
                        styles={customSelectStyles}
                        className='select-full-width-no-border'
                        value={selectedPriority}
                        getOptionLabel={e => e.value}
                        getOptionValue={e => e}
                        options={PRIORITY_LIST}
                        placeholder='Select Priority'
                        onChange={e => setSelectedPriority(e)} />}
                    <ButtonRow>
                        <CommonButton label='Submit' onClick={() => { handleAddTaxRuleSubmitClick() }} />
                    </ButtonRow>
                </Modal.Body>
            </Modal>
            <Modal
                onHide={() => {
                    setShowEditRuleModal(false)
                }}
                show={showEditRuleModal}
                size="lg"
                aria-labelledby="contained-modal-title-vcenter"
                centered
            >
                <Modal.Header closeButton>
                    <Modal.Title id="contained-modal-title-vcenter">
                        Edit Tax Rule
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <FormFieldLabel label='Edit details to update tax rule' />
                    <CommonInputFloatFull
                        type='text'
                        id='name'
                        onChange={e => setName(e.target.value)}
                        placeholder='Tax Name'
                        value={name}
                    />
                    <FormFieldLabel label='Select Value Type' />
                    {TAX_TYPE_LIST && <Select
                        styles={customSelectStyles}
                        className='select-full-width-no-border'
                        value={selectedType}
                        getOptionLabel={e => e.value}
                        getOptionValue={e => e}
                        options={TAX_TYPE_LIST}
                        placeholder='Select Value Type'
                        onChange={e => setSelectedType(e)} />}
                    {!isEmpty(selectedType) && selectedType.key === 'FIXED' && <CommonInputFloatFull
                        type='number'
                        id='valueNumber'
                        onChange={e => setValue(e.target.value)}
                        placeholder='Value'
                        value={value}
                    />}
                    {!isEmpty(selectedType) && selectedType.key !== 'FIXED' && <PercentInputHalf
                        type='number'
                        id='valueFixed'
                        onChange={e => setValue(e.target.value)}
                        placeholder='Value'
                        value={value}
                        isFullWidth={true}
                    />}
                    {!isEmpty(selectedType) && <CommonInputRow>
                        <CommonInputFloatHalf
                            type='number'
                            id='minAmount'
                            onChange={e => setMinimumAmount(e.target.value)}
                            placeholder='Min. Amount'
                            value={minimumAmount}
                        />
                        <CommonInputFloatHalf
                            type='number'
                            id='maxAmount'
                            onChange={e => setMaximumAmount(e.target.value)}
                            placeholder='Max. Amount'
                            value={maximumAmount}
                        />
                    </CommonInputRow>}
                    <FormFieldLabel label='Select Priority' />
                    {PRIORITY_LIST && <Select
                        styles={customSelectStyles}
                        className='select-full-width-no-border'
                        value={selectedPriority}
                        getOptionLabel={e => e.value}
                        getOptionValue={e => e}
                        options={PRIORITY_LIST}
                        placeholder='Select Priority'
                        onChange={e => setSelectedPriority(e)} />}
                    <ButtonRow>
                        <CommonButton label='Update' onClick={() => { handleUpdateTaxRuleSubmitClick() }} />
                    </ButtonRow>
                </Modal.Body>
            </Modal>
            <ToastContainer />
            <Loader active={isLoading} text='Please wait...' />
        </>
    )
}

export default TaxRuleList